module.exports = __webpack_public_path__ + "videos/brushes-overlay.22743e7.webm";